import StoreManager from 'component/StoreManager';
import ProductListItemCollection from 'component/ProductListItemCollection';
import SearchSuggest from 'component/SearchSuggest';
import Callback from 'component/Callback';
import Subscribe from 'component/Subscribe';
import StoreChangeConfirm from 'component/StoreChangeConfirm';
import AuthPopup from 'component/AuthPopup';
import DeleteAccPopup from 'component/DeleteAccPopup';
import SmallBasket from 'component/SmallBasket';
import TopNotice from 'component/TopNotice';
import Messengers from 'component/Messengers';
import WholesaleRequestPopup from 'component/popup/WholesaleRequestPopup';
import DefaultFormPopup from 'component/popup/DefaultFormPopup';
import B2bMessagePopup from 'component/popup/B2bMessagePopup';
import B2bBalance from 'component/B2bBalance';
import MobileSidebarMenu from 'component/MobileSidebarMenu';
import VoiceSearch from 'component/VoiceSearch';
import GoUp from 'component/GoUp';
//import "@babel/polyfill";
import 'vendor/bootstrap4/bootstrap.bundle';
import 'vendor/slick/slick';
import 'vendor/scrollbar/jquery.mousewheel';
import jqueryMCustomScrollbar from 'vendor/scrollbar/jquery.mCustomScrollbar';
import Nanobar from 'nanobar';

export default class SiteTemplate {
    constructor() {
        import(/* webpackChunkName: "ContentConcealer" */ './component/ContentConcealer').then(({default: ContentConcealer}) => {
            this.contentConcealer = ContentConcealer;
            ContentConcealer.run();
            this.initHeaderBottomMenu();
            this.initSidebarCatalogMenu();
            this.initAfterConcealer();
        });

        this.storeManager = new StoreManager;

        this.initTopMenu();
        this.initCatalogMenu();

        this.productListItemCollection = new ProductListItemCollection;
        this.smallBasket = new SmallBasket;
        this.searchSuggest = new SearchSuggest;
        this.callbackPopup = new Callback;
        this.subscribePopup = new Subscribe;
        this.storeChangeConfirmPopup = new StoreChangeConfirm;
        this.topNotice = new TopNotice;
        this.messengers = new Messengers;
        this.b2bBalance = new B2bBalance;
        WholesaleRequestPopup.init();
        this.bindCustomFormPopups();
        B2bMessagePopup.init();
        VoiceSearch.init();
        new GoUp();
        this.initPWA();

        $('[data-toggle="popover"]').popover();

        if ($('.header-middle__search-barcode-button').length > 0) {
            import(/* webpackChunkName: "BarcodeScanner" */ './component/BarcodeScanner').then(({default: BarcodeScanner}) => {
                BarcodeScanner.init();
            });
        }
  
        this.deleteAccPopup = new DeleteAccPopup();
    }

    initAfterConcealer() {
        if (app.userId == 0) {
            this.authPopup = new AuthPopup;
        }
    }

    initTopMenu() {
        //ховер на 992+ переключает выпадающее меню в самом верхнем меню
        $('.header-top__menu-item.has-submenu')
            .on('mouseenter', (e) => {
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $(e.currentTarget).addClass('active');
                }
            })
            .on('mouseleave', (e) => {
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $(e.currentTarget).removeClass('active');
                }
            });

        //клик на 991- переключает выпадение самого верхнего меню
        $('.header-top__menu-item.has-submenu').on('click', function (e) {
            if (window.matchMedia('(max-width: 991px)').matches) {
                e.preventDefault();
                $('.header-top__menu-item.has-submenu').not(this).removeClass('active');
                $(this).toggleClass('active');
            }
        });
    }

    initHeaderBottomMenu() {
        if (false && $('body').hasClass('bx-touch')) {
        } else {
            $('.header-bottom-menu-item')
                .on('mouseenter', (e) => {
                    if (window.matchMedia('(min-width: 992px)').matches) {
                        $(e.currentTarget).addClass('header-bottom-menu-item--active');
                    }
                })
                .on('mouseleave', (e) => {
                    if (window.matchMedia('(min-width: 992px)').matches) {
                        $(e.currentTarget).removeClass('header-bottom-menu-item--active');
                    }
                });

            $('.header-bottom-menu-item__inner').on('click', (e) => {
                // (min-width: 768px) and (max-width: 991px)
                if (window.matchMedia('(max-width: 991px)').matches) {
                    if ($(e.currentTarget).siblings('.header-bottom-menu-item__submenu').length === 0) {
                        return;
                    }

                    const $el = $(e.currentTarget).closest('.header-bottom-menu-item');

                    e.preventDefault();

                    $('.header-bottom-menu-item').not($el).removeClass('header-bottom-menu-item--active');
                    $el.toggleClass('header-bottom-menu-item--active');
                }
            });
        }
    }

    initCatalogMenu() {
        MobileSidebarMenu.init();
        //$('.header-middle__m-menu-toggler').on('click', this.showMobileCatalogMenu.bind(this));

        //нажатие на "каталог товаров" на 991- открывает модальное окно с меню
        $('.header-catalog-menu-button').on('click', () => {
            if (!window.matchMedia('(max-width: 991px)').matches) {
                return;
            }

            this.showMobileCatalogMenu();
        });

        // Fix menu cut when page doesn't have enough content
        $('.header-catalog-menu-button')
            .on('mouseenter', (e) => {
                if (window.matchMedia('(max-width: 991px)').matches) {
                    return;
                }

                $('.catalog-wide-menu').toggleClass('hidden', false);
                this.fixPageHeightByMenu();
            })
            .on('mouseleave', (e) => {
                if (window.matchMedia('(max-width: 991px)').matches) {
                    return;
                }

                this.hideCatalogMenu = true;

                setTimeout(() => {
                    if (!this.hideCatalogMenu) {
                        return;
                    }

                    $('.catalog-wide-menu').toggleClass('hidden', true);
                    this.resetPageHeight();
                }, 50);
            });

        $('.catalog-wide-menu')
            .on('mouseenter', (e) => {
                this.hideCatalogMenu = false;
            })
            .on('mouseleave', (e) => {
                $('.catalog-wide-menu').toggleClass('hidden', true);
            });

        $('.header-bottom .catalog-menu')
            .on('mouseenter', (e) => {
                if (!window.matchMedia('(max-width: 991px)').matches) {
                    return;
                }

                this.fixPageHeightByMenu();
            })
            .on('mouseleave', (e) => {
                this.resetPageHeight();
            });
        //кнопка поиска в мобильной версии открывает поле поиска
        $('.js__search-block-toggler').on('click', function () {
            $('.header-middle__search-block').slideToggle();
        });

        $('.js-header-middle__phone-button').on('click', function () {
            $('.js-header-middle__phone-dropdown-menu').slideToggle();
        });

    }

    showMobileCatalogMenu() {
        const $container = $('.catalog-menu-modal__menu-container');

        if ($container.children().length == 0) {
            $container.append($('.catalog-wide-menu').clone());
            $container.find('.catalog-wide-menu').removeClass('hidden').addClass('catalog-wide-menu--modal');
        }

        $('.catalog-menu-modal').modal('show');
    }

    fixPageHeightByMenu() {
        $('.content-container').css('min-height', $('.header-bottom .catalog-menu').height() + 20);
    }

    resetPageHeight() {
        $('.content-container').css('min-height', '');
    }

    /**
     * When PageState.useSidebar is on and container is placed,
     * we can show catalog menu in sidebar instead of hover popup
     */
    initSidebarCatalogMenu() {
        const $placement = $('.sidebar-catalog-menu-placement');

        if ($placement.length == 0) {
            return;
        }

        $placement.prepend($('.catalog-menu'));
        $('.header-catalog-menu-button').addClass('header-catalog-menu-button--stub');
    }

    bindCustomFormPopups() {
        $('.js-form-popup').on('click', (e) => {
            e.preventDefault();
            // data-form-id
            new DefaultFormPopup({
                formId: 1,
                textBefore: 'Заполните заявку и наш менеджер свяжется с вами по поводу приобретения защитной пленки',
                fields: [
                    { type: 'name' },
                    { type: 'phone' },
                    {
                        label: 'Модель телефона',
                        code: 'model',
                        required: true,
                    },
                ],
            });
        });
    }

    initPWA() {
        this.initPWALoadIndicator();
        this.initServiceWorker();
    }

    initPWALoadIndicator() {
        if (!(navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches === true)) {
            return;
        }

        this.nanobar = new Nanobar();

        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('a')) {
                return;
            }

            const href = e.target.closest('a').getAttribute('href');

            if (['#', 'javascript:void(0)', null].includes(href)) {
                return;
            }

            e.preventDefault();
            //this.showPWASLoadIndicator();
            document.querySelector('.pwa-loader__progress').classList.add('pwa-loader__progress--100');

            setTimeout(() => {
                document.location.href = href;
            }, 100);
        }, { capture: true });
        /*$(document.body).on('click', 'a', (e) => {
            const href = $(e.currentTarget).attr('href');

            if (['#', 'javascript:void(0)'].includes(href)) {
                return;
            }

            this.showPWASLoadIndicator();
        });*/
    }

    initServiceWorker() {
        window.addEventListener("load", () => {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.register('/local/templates/liberti2018/js/sw.js');
            }
        });
    }

    showPWASLoadIndicator()
    {
        clearInterval(this.pwaIndicatorInterval);

        let x = 0;
        let step = 0.01;
        const func = (x) => { return 1 - Math.pow(3, -4 * x) };

        this.pwaIndicatorInterval = setInterval(() => {
            x = x + step;
            let y = 100 * func(x);
            this.nanobar.go(y);

            if (x > 50) {
                step = 0.1;
            }

            if (x > 0.98) {
                clearInterval(this.pwaIndicatorInterval);
            }
        }, 100);
    }
}